/**
 * Relativo curto em pt-BR para “última sync” e banners.
 */
export function formatRelativePt(iso: string, now = Date.now()): string {
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return "";
  const deltaSec = Math.round((now - then) / 1000);
  if (deltaSec < 20) return "agora";
  if (deltaSec < 60) return `há ${deltaSec} s`;
  const minutes = Math.round(deltaSec / 60);
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return hours === 1 ? "há 1 h" : `há ${hours} h`;
  const days = Math.round(hours / 24);
  if (days < 7) return days === 1 ? "há 1 dia" : `há ${days} dias`;
  return new Date(iso).toLocaleString("pt-BR");
}
